import { Actions, AppMiddleware, AppDispatch } from '..';
import { SET_SELECTED_CONFIGURATION } from '../sofaConfiguration';
import { setNoRotationIcon, showRotationIcon } from '../scene';
import { SET_DRAG_ITEM_ID } from '../swiper';

let rotationIconTimer = -1;

function resetTimer(dispatch: AppDispatch): void {
	clearTimeout(rotationIconTimer);
	dispatch(showRotationIcon(true));
	rotationIconTimer = window.setTimeout((): void => {
		dispatch(showRotationIcon(false));
	}, 2000);
}

function clearTimer(dispatch: AppDispatch): void {
	clearTimeout(rotationIconTimer);
	dispatch(showRotationIcon(false));
}

const rotationIconMiddleware: AppMiddleware =
	(api) =>
	(next) =>
	(action: Actions): Actions => {
		const result = next(action);
		const state = api.getState();
		const { noRotationIcon } = state.scene;
		switch (action.type) {
			case SET_SELECTED_CONFIGURATION:
				resetTimer(api.dispatch);
				break;
			case SET_DRAG_ITEM_ID:
				if (action.value === null) {
					if (!noRotationIcon) {
						resetTimer(api.dispatch);
					} else {
						api.dispatch(setNoRotationIcon(false));
					}
				} else {
					clearTimer(api.dispatch);
				}
				break;
		}

		return result;
	};

export { rotationIconMiddleware };
